import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag'

const Home=({data:{loading,allUsers}})=>{
    return (loading ? null : allUsers.map(u=><h1 key={u.id }>{u.email}</h1>));
}

const allUsersQuery=gql`
{
    allUsers{
        id
        email
    }
}
`;
 
export default graphql(allUsersQuery)(Home);